import { UpdatePersonalInfoBody } from '../api/useUpdatePersonalInfoMutation';
import { BENEFICIARIES } from '../components/Dependents/Dependents.meta';
import { FormValues } from '../PersonalInfo.meta';

interface FormToBodyParams {
  keepDeletedPartnerData: boolean | null;
  showPartnerSection: boolean;
  values: FormValues;
}

export const formToBodyPersonalInfo = ({
  values,
  keepDeletedPartnerData,
  showPartnerSection,
}: FormToBodyParams): UpdatePersonalInfoBody => {
  return {
    KeepDeletedPartnerAssociations: keepDeletedPartnerData,

    Principal: {
      FirstName: values.personalInfo.principal.firstName,
      LastName: values.personalInfo.principal.lastName,
      Dob: values.personalInfo.principal.dob,
    },

    Partner: showPartnerSection
      ? {
          FirstName: values.personalInfo.partner.firstName,
          LastName: values.personalInfo.partner.lastName,
          Dob: values.personalInfo.partner.dob,
        }
      : null,

    Taxes: {
      FilingState: values.personalInfo.filingState,
      FilingStatus: values.personalInfo.filingStatus,
    },

    Dependents: values.personalInfo.dependents.map(dependent => {
      if (BENEFICIARIES.includes(dependent.type)) {
        return {
          Id: dependent.id || null,
          FirstName: dependent.firstName,
          Type: dependent.type,
        };
      }

      return {
        Id: dependent.id || null,
        FirstName: dependent.firstName,
        Dob: `01-01-${dependent.yearOfBirth}`,
        Type: dependent.type,
        IsDependent: dependent.isDependent,
      };
    }),
  };
};
